import { FC } from 'react';
import { useIntl } from 'react-intl';

import { ReminderTileLayout } from '../components';

export const BrokenTile: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { formatMessage } = useIntl();
  return (
    <ReminderTileLayout
      icon="sync_problem"
      titleKey="dashboard.broken.title"
      messageKey="dashboard.broken.content"
      className="text-secondary"
    >
      <button className="btn btn-xl btn-discreet-secondary flex-grow-1" onClick={onClose}>
        {formatMessage({ id: 'dashboard.remove' })}
      </button>
    </ReminderTileLayout>
  );
};

BrokenTile.displayName = 'BrokenTile';
